// ! This file was auto-generated from the sylvanus OpenAPI schema. Do not override this file.
export const Tags = {
    agent_execution: "agent_execution",
    clause: "clause",
    conversation: "conversation",
    dde: "dde",
    disclaimer: "disclaimer",
    healthcheck: "healthcheck",
    internal: "internal",
    library: "library",
    model: "model",
    no_rbac: "no_rbac",
    platform_admin: "platform_admin",
    private_conversation: "private_conversation"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
